import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions',
	path: '/secure/admin/ViewResolutions.jspa',
};
